import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { opsApi } from "../../lib/api";
import Hint from "@/components/Hint";

const whole = (v) => (v == null ? "" : String(Math.round(Number(v) * 100)));

/** The two GM defaults "Add to CO" uses on this job — compact, lives on the CO toolbar. */
export default function CoMarginDefaults({ project, reload }) {
  const m = project.co_margins || {};
  const [form, setForm] = useState({ material: "", labor: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setForm({ material: whole(m.material_gm), labor: whole(m.labor_gm) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.id, m.material_gm, m.labor_gm]);

  const commit = async () => {
    const patch = {
      material_gm: form.material === "" ? null : Math.max(0, Math.round(Number(form.material))) / 100,
      labor_gm: form.labor === "" ? null : Math.max(0, Math.round(Number(form.labor))) / 100,
    };
    if (whole(patch.material_gm) === whole(m.material_gm) && whole(patch.labor_gm) === whole(m.labor_gm)) return;
    setBusy(true);
    try {
      await opsApi.patchProject(project.id, { ops_co_margins: patch });
      toast.success("Change order margins saved");
      await reload?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "That could not be saved"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2 text-xs" data-testid="ops-co-margin-defaults" title={m.explanation || ""}>
      {[["material", "M", "Default material GM% for new CO lines"], ["labor", "L", "Default labor GM% for new CO lines"]].map(([key, label, hint]) => (
        <label key={key} className="flex items-center gap-1 text-slate-500">
          <Hint text={hint}>{label}</Hint>
          <span className="relative">
            <Input type="text" inputMode="numeric" value={form[key]} disabled={busy}
                   onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value.replace(/\D/g, "") }))}
                   onBlur={commit} onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
                   className="h-8 w-16 pr-6 text-xs tabular-nums" data-testid={`ops-co-margin-${key}`} />
            <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-slate-400">%</span>
          </span>
        </label>
      ))}
    </div>
  );
}
